import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { TableColumn } from 'src/app/models/TableColumn';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { DialogService } from '../../../services/dialog.service';
import { PartnersService } from '../../../services/partners.service';
import { DistributorsService } from '../../../services/distributors.service';
import { Do } from '../../../shared/utils';
import { createAwaitable } from '../../../shared/AwaitableObservable';
import { UserGroupDTO } from '../../../models/UserGroupDTO.model';
import { ResponseListUserPartnerDTO } from '../../../shared/models/ApiResponse';
import { UserPartnerDTO } from '../../../models/UserPartnerDTO.model';
import { TransferPartnerDTO } from '../../../models/TransferPartnerDTO.model';
declare var bootstrap: any;

@Component({
    selector: 'app-list-distributor-customer',
    templateUrl: './list-distributor-customer.component.html',
    styleUrls: ['./list-distributor-customer.component.css'],
    imports: [CommonModule, FormsModule, TableControlComponent]
})
export class ListDistributorCustomerComponent {
  @Input() distributorDataInput: any;

  public dialog = inject(DialogService);
  private customerService = inject(CustomerService);
  private distributorService = inject(DistributorsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private alertService = inject(AlertService);
  public permissionsService = inject(ValidatePermissionsService);
  public paginationService = inject(PaginationService);


  distributorCustomerList: UserPartnerDTO[] = [];
  originalDistributorCustomerList: any[] = [];
  selectedCustomer: UserPartnerDTO = {} as UserPartnerDTO;
  alert: Alert = {} as Alert;
  userRequestDTO: UserRequestDTO = { userId: undefined };
  public selectedCustomers: UserPartnerDTO[] = [];

  columns: TableColumn[] = [
    { key: 'customerAccount', header: 'Customer Account', width: 1 },
    {
      key: 'userNames', header: 'Name',
      render: (value: any, row?: any) => {
        // только если есть доступ к Customers
        if (this.permissionsService.customers.readPermission) {
          return `<a link href="/customers/customer-account/${row.customerAccount}">${value}</a>`;
        } else {
          return value;
        }
      }
    },
    { key: 'userMail', header: 'Email', width: 1 },
    { key: 'userPhone', header: 'Contact Number', width: 1 },
    { key: 'numberPlans', header: '# Plans', width: 1 },
    {
      key: 'userStatus', header: 'Status', width: 1,
      render: (value: any, row?: any) => {
        return '<div class="form-check form-switch">' +
          `<input class="form-check-input" type="checkbox" ${value == 1 ? 'checked' : ''} disabled />` +
          '</div>';
      }
    }
  ];

  actionButtons = [
    { label: 'edit', class: 'primary', icon: 'bi bi-pencil' },
    { label: 'archive', class: 'danger', icon: 'bi bi-archive' }
  ];

  ngOnInit() { this.loadCustomers(); }

  loadCustomers() {
    this.userRequestDTO.userId = this.distributorDataInput?.userId ?? this.distributorDataInput;
    this.updateDistributorCustomerList();
  }

  async updateDistributorCustomerList() {
    this.distributorCustomerList = await this.distributorService.getListCustomersByDistributorIdAsync(this.userRequestDTO.userId);
  }


  //#region - Assign Customers -
  assignCustomersColumns: TableColumn[] = Do([...this.columns], x => x.pop());

  public customersToAssignList: UserPartnerDTO[] = [];
  public selectedCustomersToAssign: UserPartnerDTO[] = [];

  public async assignCustomers() {
    const availableCustomers = await this.distributorService.getListCustomersAvailablesAsync();
    this.customersToAssignList = availableCustomers;
    this.customersToAssignList = this.distributorCustomerList.concat(this.customersToAssignList);
    this.selectedCustomersToAssign = [...this.distributorCustomerList]

    if (!(await this.dialog.open('modalAssignCustomers'))) return;

    let listUserGroup: UserGroupDTO[] = this.customersToAssignList.map(customer => <UserGroupDTO>{
      AUsrId: customer.customerAccount,
      APartnerId: this.distributorDataInput.userId,
      Checked: this.selectedCustomersToAssign.contains(customer)
    });

    await this.distributorService.addCustomersDistributorAsync(listUserGroup);
    await this.updateDistributorCustomerList();
  }
  //#endregion - Assign Customers -


  //#region - Transfer Customers -

  transferDistributorsColumns: TableColumn[] = [
    { key: 'idPartner', header: 'Distributor ID', width: 1 },
    { key: 'namePartner', header: 'Name' },
    { key: 'mailPartner', header: 'Email', width: 1 },
    { key: 'phone', header: 'Contact Number', width: 1 },
    { key: 'totalPartners', header: 'Total Partners', width: 1 },
    { key: 'totalCustomers', header: 'Total Customers', width: 1 },
  ];

  
  public distributorsToTransferList: TransferPartnerDTO[] = [];
  public selectedDistributorsToTransfer: TransferPartnerDTO[] = [];

  async transferCustomers() {
    const distributors = await this.distributorService.getAllDistributorsAvailablesAsync();
    this.distributorsToTransferList = distributors.filter(d => d.idPartner !== this.distributorDataInput.userId);
    this.selectedDistributorsToTransfer = [];
    if (!(await this.dialog.open('modalTransferCustomers'))) return;

    const selectedDistributor = this.selectedDistributorsToTransfer[0];
    if (!selectedDistributor) return;

    const listUserGroup: UserGroupDTO[] = this.selectedCustomers.map(p => ({
        AUsrId: p.customerAccount,
        APartnerId: selectedDistributor.idPartner
      }));
    this.selectedCustomers = [];
    await this.distributorService.updateCustomersDistributor(listUserGroup);
    await this.updateDistributorCustomerList();

  }
  //#endregion - Transfer Customers -

}
